<template>
  <div class="container-fluid">

    <div class="container-fluid bg-base-green trees-bg">
      <div class="row pt-5 pb-5">
        <div class="col-12">
          <h1 class="title text-center">{{$t('observatorio_about')}}</h1>          
        </div>      
      </div>
    </div>    
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-9 mt-3">
          <p class="mt-3 plataforma-parrafo">
             {{$t('observatorio_texto_uno')}}
          </p>          
          <p class="mt-3 plataforma-parrafo">
            {{$t('observatorio_texto_tres')}}
            
          </p>
          <p class="mt-3 plataforma-parrafo ">
            {{$t('observatorio_texto_cuatro')}}
            
          </p>
          <p class="mt-3 plataforma-parrafo">
            {{$t('observatorio_texto_dos')}}                        
          </p>
          <p class="mt-3 plataforma-parrafo">
            <span v-html="$t('observatorio_texto_cinco')"></span>
            
          </p>  
          <p class="mt-3 plataforma-parrafo">
            {{$t('observatorio_texto_seis')}}
            
          </p>
          <div class="row justify-content-center border-bottom border-top mb-3">
            <div class="col-12 col-md-10">
              <div class="mt-3 mb-3" v-html="$t('observatorio_instructivo')"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
            </svg></div>             
            </div>
          </div>
            <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_titulo_uno')}}</h2>
          <p class="mt-3 plataforma-parrafo ">
            {{$t('observatorio_h2_parrafo_uno')}}
            
          </p>
          <p>
            {{$t('observatorio_h2_parrafo_dos')}}
            
          </p>
          <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_parrafo_diecisiete')}}</h2>
          <p class="mt-3 plataforma-parrafo">
           <span v-html="$t('observatorio_h2_parrafo_dieciocho')"></span>
          </p>          
          
            <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_titulo_dos')}}</h2>
          <p class="mt-3 plataforma-parrafo ">
            {{$t('observatorio_h2_parrafo_tres')}}
          </p>
            <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_titulo_tres')}}</h2>
          <p class="mt-3 plataforma-parrafo ">
            <span v-html="$t('observatorio_h2_parrafo_cuatro')"></span>
            
          </p>
            <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_titulo_cuatro')}}</h2>
          <p class="mt-3 plataforma-parrafo ">
            <span v-html="$t('observatorio_h2_parrafo_cinco')"></span>            
          </p>
            <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_titulo_cinco')}}</h2>
          <p class="mt-3 plataforma-parrafo ">
            {{$t('observatorio_h2_parrafo_seis')}}
          </p>
            <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_titulo_seis')}}</h2>
          <p class="mt-3 plataforma-parrafo ">
            <span v-html="$t('observatorio_h2_parrafo_siete')"></span>
          </p>
          <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_parrafo_diecinueve')}}</h2>          
          <p class="mt-3 plataforma-parrafo">
           <span v-html="$t('observatorio_h2_parrafo_veinte')"></span>
          </p>
            <h2 class="plataforma-subtitulo">{{$t('observatorio_h2_titulo_siete')}}</h2>
          <p class="mt-3 plataforma-parrafo ">
            {{$t('observatorio_h2_parrafo_ocho')}} 
          </p>               
          <p class="mt-3 border-top plataforma-parrafo ">{{$t('observatorio_h2_parrafo_nueve')}}
          </p>
          <p class="mt-3 plataforma-farrafo">
            <span v-html="$t('observatorio_h2_parrafo_diez')"></span>
          </p>
          <p class="mt-3 plataforma-parrafo">
           <span v-html="$t('observatorio_h2_parrafo_once')"></span>
          </p>
          <p class="mt-3 plataforma-parrafo">
           <span v-html="$t('observatorio_h2_parrafo_doce')"></span>
          </p>
          <p class="mt-3 plataforma-parrafo">
           <span v-html="$t('observatorio_h2_parrafo_trece')"></span>
          </p>
          <p class="mt-3 plataforma-parrafo">
           <span v-html="$t('observatorio_h2_parrafo_catorce')"></span>
          </p>
          <p class="mt-3 plataforma-parrafo">
           <span v-html="$t('observatorio_h2_parrafo_quince')"></span>
          </p>
          <p class="mt-3 plataforma-parrafo">
           <span v-html="$t('observatorio_h2_parrafo_dieciseis')"></span>
          </p>          
        </div>
      </div>
    </div>
        
   

  </div>
</template>

<script>

  export default {
    name : 'Plataforma'
  }

</script>